/** @format */

export const DEFAULT_TEST_ID = 'product-search-results';
